import './core/components/app/style.pcss';

import App from './core/components/app/app.js'
import CookieConsent from './core/components/app/elements/chunks/cookie-consent/cookie-consent.js'
import Header from './core/components/app/elements/chunks/header/header.js'
import Accordeon from './core/components/app/elements/chunks/accordeon-base/accordeon-base.js'
import BoxCarousel from './core/components/app/elements/chunks/box-carousel-base/box-carousel-base.js'
import BoxReadmore from './core/components/app/elements/chunks/box-readmore-base/box-readmore-base.js'
import FormContact from './core/components/app/elements/chunks/form-contact/form-contact.js'
import ListJobs from './core/components/app/elements/chunks/list-jobs/list-jobs.js'
import TeaserNewsPageSlider from './core/components/app/elements/chunks/teaser-news-page-slider/teaser-news-page-slider.js'
import TeaserProductPageSlider from './core/components/app/elements/chunks/teaser-product-page-slider/teaser-product-page-slider.js'
import TimelineHistory from './core/components/app/elements/chunks/timeline-history/timeline-history.js'
import TitleStartpageSlider from './core/components/app/elements/chunks/title-startpage-slider/title-startpage-slider.js'

document.addEventListener("DOMContentLoaded", function (event) {
    console.log('DOMContentLoaded', event);
    App.init();
    CookieConsent.init();
    Header.init();
    Accordeon.init();
    BoxCarousel.init();
    BoxReadmore.init();
    FormContact.init();
    ListJobs.init();
    TeaserNewsPageSlider.init();
    TeaserProductPageSlider.init();
    TimelineHistory.init();
    TitleStartpageSlider.init();
});

if (module.hot) {
    module.hot.accept('./core/components/app/app.js', App.init);
    module.hot.accept('./core/components/app/elements/chunks/cookie-consent/cookie-consent.js', CookieConsent.init);
    module.hot.accept('./core/components/app/elements/chunks/header/header.js', Header.init);
    module.hot.accept('./core/components/app/elements/chunks/accordeon-base/accordeon-base.js', Accordeon.init);
    module.hot.accept('./core/components/app/elements/chunks/box-carousel-base/box-carousel-base.js', BoxCarousel.init);
    module.hot.accept('./core/components/app/elements/chunks/box-readmore-base/box-readmore-base.js', BoxReadmore.init);
    module.hot.accept('./core/components/app/elements/chunks/form-contact/form-contact.js', FormContact.init);
    module.hot.accept('./core/components/app/elements/chunks/list-jobs/list-jobs.js', ListJobs.init);
    module.hot.accept('./core/components/app/elements/chunks/teaser-news-page-slider/teaser-news-page-slider.js', TeaserNewsPageSlider.init);
    module.hot.accept('./core/components/app/elements/chunks/teaser-product-page-slider/teaser-product-page-slider.js', TeaserProductPageSlider.init);
    module.hot.accept('./core/components/app/elements/chunks/timeline-history/timeline-history.js', TimelineHistory.init);
    module.hot.accept('./core/components/app/elements/chunks/title-startpage-slider/title-startpage-slider.js', TitleStartpageSlider.init);
}
